import React, { Component } from 'react';
import Wrp from '../../hoc/Wrp/Wrp';
import Select from 'react-select';
import { setAndGetAttributes } from '../FormInputFields/FormInputFunctions';
import makeAnimated from 'react-select/animated';
import { isSet } from '../../Utils/CommonFunctions';

class PagesMultiselect extends Component {
  fieldOnChangeHandler = (options, values) => {
    const { changeHandler } = this.props;
    switch (values !== undefined ? values.action : 'others') {
      case 'remove-value':
        if (values.removedValue.isFixed === true) {
          return;
        }
      case 'pop-value':
        if (values.removedValue.isFixed === true) {
          return;
        }
        break;
      case 'clear':
        options = options.filter((v) => {
          if (v.isFixed !== true) {
            return v;
          }
        });
        break;
    }
   
    const opt = isSet(options,[]).map((item) => {
      return {
        // id: item.id,
        value: item.value,
        name: item.label,
        // text: item.value,
      }
    });
    //  console.log('options',opt);
    changeHandler(opt);
  };
 
  render() {
    const { value, options, max } = this.props;
    const animatedComponents = makeAnimated();
    let attr = setAndGetAttributes(this.props);
    
    let defaultValueOptions = [];
    const valueArray = isSet(value, []);
    
    options.map((item)=>{
        // Check if item.value exists in value array
        // Handle both cases: value as array of primitives or array of objects
        let isValueExists = false;
        
        if (Array.isArray(valueArray) && valueArray.length > 0) {
          // Check if value is array of objects (has 'value' property)
          if (valueArray[0] && typeof valueArray[0] === 'object' && valueArray[0].value !== undefined) {
            // Array of objects: check if any object's value property matches item.value
            isValueExists = valueArray.some(v => v.value === item.value);
          } else {
            // Array of primitives: use indexOf
            isValueExists = valueArray.indexOf(item.value) !== -1;
          }
        }
        
        if (isValueExists) {
          item.checked = true;
          defaultValueOptions.push(item);
        }
    })
    // console.log('defaultValueOptions',defaultValueOptions);
    return (
      <Wrp>
        <div className={this.props.isMandatory && this.props.isMandatory === true ? 'mandatory' : ''}>
          <Select
            isMulti={true}
            classNamePrefix="form-control"
            onChange={(e) => this.fieldOnChangeHandler(e)}
            {...attr}
            className=""
            isClearable={false}
            isOptionDisabled={max !== null ? () => isSet(value, []).length >= max : false}
            options={options}
            value={defaultValueOptions}
          />
        </div>
      </Wrp>
    );
  }
}

PagesMultiselect.defaultProps = {
  disabled: false,
  readOnly: false,
  className: 'form-control',
  max: null,
};

export default PagesMultiselect;


